import type { RootState } from '@app/types';

// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import type { LoginFormDataType } from './pages/LoginPage/types';
// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import type { ResetFormDataType } from './pages/ResetPage/types';
import type { TwoFactorFormDataType } from './pages/TwoFactorPage';
import type { SignupFormDataType } from './router/SignupRouter';

export const loginSelector = (state: RootState) => state.auth.login;
export const signupSelector = (state: RootState) => state.auth.signup;
export const resetPasswordSelector = (state: RootState) => state.auth.resetPassword;
export const twoFactorSelector = (state: RootState) => state.auth.twoFactor;
export const ssoSelector = (state: RootState) => state.auth.sso;

export const getLoginFormData = (state: RootState): LoginFormDataType => state.auth.login.formData;
export const getSignupFormData = (state: RootState): SignupFormDataType => state.auth.signup.formData;
export const getResetFormData = (state: RootState): ResetFormDataType => state.auth.resetPassword.formData;
export const getTwoFactorFormData = (state: RootState): TwoFactorFormDataType => state.auth.twoFactor.formData;
